<template>
	<div class="floating-ad wave-animation" :class="{ 'paused': isPaused }"
		:style="{ left: position.x + 'px', top: position.y + 'px' }" @mouseenter="pauseAnimation"
		@mouseleave="resumeAnimation">
		<!-- <div class="flag-container">
			<div class="close-btn" @click.stop="closeAd">×</div>
			<div class="flag-pole"></div>
			<div class="flag-cloth" @click.stop="flagClick">
				<div class="flag-content">
					<h4>VR影院</h4>
					<p>点击跳转</p>
				</div>
				<div class="flag-wave"></div>
			</div>
		</div> -->
		<img src="../assets/vr.png" @click.stop="flagClick"/>
	</div>
</template>

<script>
	export default {
		template: '#floating-ad-template',
		props: {
			speed: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				position: {
					x: 100,
					y: 100
				}, // 初始位置
				directionX: 1,
				directionY: 1,
				isPaused: false,
				moveInterval: null,
				// 调整点12: 移除固定的boundaryWidth/boundaryHeight，使用window.innerWidth/Height
				adWidth: 180,
				adHeight: 120,
				// 调整点13: 添加可视区域尺寸
				viewportWidth: window.innerWidth,
				viewportHeight: window.innerHeight
			};
		},
		mounted() {
			// 调整点14: 初始位置在可视区域内随机
			this.resetPosition();

			this.startFloating();

			// 调整点15: 添加窗口大小变化监听
			window.addEventListener('resize', this.handleResize);
		},
		
		methods: {
			startFloating() {
				if (this.moveInterval) clearInterval(this.moveInterval);

				this.moveInterval = setInterval(() => {
					if (!this.isPaused) {
						// 更新位置
						this.position.x += this.directionX * this.speed;
						this.position.y += this.directionY * this.speed;

						// 调整点16: 使用checkViewportBoundaries代替checkBoundaries
						this.checkViewportBoundaries();
					}
				}, 16); // 约60fps
			},
			stopFloating() {
				if (this.moveInterval) {
					clearInterval(this.moveInterval);
					this.moveInterval = null;
				}
			},
			// 调整点17: 完全重写边界检查逻辑，基于可视区域
			checkViewportBoundaries() {
				// 更新可视区域尺寸（窗口大小可能已变化）
				this.viewportWidth = window.innerWidth;
				this.viewportHeight = window.innerHeight;

				// 边界检查，确保广告始终在可视区域内
				const margin = 5; // 边距，避免广告紧贴边缘

				// 检查X边界
				if (this.position.x <= margin) {
					this.position.x = margin;
					this.directionX = 1;
				} else if (this.position.x >= this.viewportWidth - this.adWidth - margin) {
					this.position.x = this.viewportWidth - this.adWidth - margin;
					this.directionX = -1;
				}

				// 检查Y边界
				if (this.position.y <= margin) {
					this.position.y = margin;
					this.directionY = 1;
				} else if (this.position.y >= this.viewportHeight - this.adHeight - margin) {
					this.position.y = this.viewportHeight - this.adHeight - margin;
					this.directionY = -1;
				}

				// 随机方向变化，使运动更自然
				if (Math.random() < 0.005) {
					this.directionX *= -1;
				}
				if (Math.random() < 0.005) {
					this.directionY *= -1;
				}
			},
			pauseAnimation() {
				this.isPaused = true;
			},
			resumeAnimation() {
				this.isPaused = false;
			},
			flagClick(){
				this.$emit('flagClick');
			},
			// 调整点18: 添加关闭广告方法
			closeAd() {
				this.stopFloating();
				this.$emit('close');
			},
			// 调整点19: 添加重置位置方法
			resetPosition() {
				this.viewportWidth = window.innerWidth;
				this.viewportHeight = window.innerHeight;

				// 随机位置，确保在可视区域内
				this.position.x = Math.random() * (this.viewportWidth - this.adWidth - 20) + 10;
				this.position.y = Math.random() * (this.viewportHeight - this.adHeight - 20) + 10;

				// 随机方向
				this.directionX = Math.random() > 0.5 ? 1 : -1;
				this.directionY = Math.random() > 0.5 ? 1 : -1;
			},
			// 调整点20: 添加窗口大小变化处理
			handleResize() {
				// 窗口大小变化时，确保广告仍在可视区域内
				this.viewportWidth = window.innerWidth;
				this.viewportHeight = window.innerHeight;

				// 如果广告位置超出新的可视区域，调整位置
				if (this.position.x > this.viewportWidth - this.adWidth) {
					this.position.x = this.viewportWidth - this.adWidth - 10;
				}
				if (this.position.y > this.viewportHeight - this.adHeight) {
					this.position.y = this.viewportHeight - this.adHeight - 10;
				}

				this.checkViewportBoundaries();
			}
		},
		beforeDestroy() {
			this.stopFloating();
			// 调整点21: 移除事件监听
			window.removeEventListener('resize', this.handleResize);
		}
	}
</script>

<style scoped lang="less">
	/* 旗帜广告组件样式 */
	.floating-ad {
		position: fixed;
		/* 改为固定定位，基于可视区 */
		cursor: pointer;
		transition: transform 0.3s ease;
		z-index: 999999;
		/* 提高z-index确保在页面内容之上 */
		filter: drop-shadow(0 5px 10px rgba(0, 0, 0, 0.2));
	}

	.floating-ad:hover {
		transform: scale(1.05);
	}

	.flag-container {
		position: relative;
		width: 180px;
		height: 120px;
	}

	.flag-pole {
		position: absolute;
		left: 10px;
		top: 0;
		width: 6px;
		height: 100%;
		background: linear-gradient(to bottom, #7f8c8d, #2c3e50);
		border-radius: 3px;
		z-index: 2;
	}

	.flag-cloth {
		position: absolute;
		left: 16px;
		top: 10px;
		width: 150px;
		height: 100px;
		border-radius: 0 8px 8px 0;
		overflow: hidden;
		z-index: 1;
		transform-origin: left center;
	}

	.flag-content {
		position: absolute;
		width: 100%;
		height: 100%;
		background: linear-gradient(135deg,  #d04ed6, #f27121);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding: 10px;
		color: white;
		font-weight: bold;
		border-radius: 0 8px 8px 0;
	}

	.flag-content h4 {
		font-size: 1.2rem;
		margin-bottom: 5px;
		text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
	}

	.flag-content p {
		font-size: 0.8rem;
		opacity: 0.9;
	}

	.flag-wave {
		position: absolute;
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0.1);
		top: 0;
		left: 0;
		border-radius: 0 8px 8px 0;
	}

	/* 旗帜飘动动画 */
	@keyframes wave {

		0%,
		100% {
			transform: skewY(0deg) scaleY(1);
		}

		25% {
			transform: skewY(2deg) scaleY(0.95);
		}

		50% {
			transform: skewY(0deg) scaleY(0.9);
		}

		75% {
			transform: skewY(-2deg) scaleY(0.95);
		}
	}

	@keyframes wave-shape {

		0%,
		100% {
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 50%, 0% 50%);
		}

		25% {
			clip-path: polygon(0 10%, 100% 0, 100% 90%, 0 100%, 0 60%, 0% 40%);
		}

		50% {
			clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%, 0 50%, 0% 50%);
		}

		75% {
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 40%, 0% 60%);
		}
	}

	.wave-animation .flag-cloth {
		animation: wave 3s ease-in-out infinite;
	}

	.wave-animation .flag-wave {
		animation: wave-shape 3s ease-in-out infinite;
	}

	.paused .flag-cloth,
	.paused .flag-wave {
		animation-play-state: paused !important;
	}

	/* 调整点2: 添加关闭按钮样式 */
	.close-btn {
		position: absolute;
		top: -5px;
		right: -5px;
		width: 25px;
		height: 25px;
		background-color: #e74c3c;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: white;
		font-weight: bold;
		font-size: 16px;
		cursor: pointer;
		z-index: 3;
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
		transition: all 0.3s ease;
	}

	.close-btn:hover {
		background-color: #c0392b;
		transform: scale(1.2);
	}

	/* 调整点3: 添加边界指示器样式 */
	.boundary-indicator {
		position: fixed;
		border: 2px dashed rgba(52, 152, 219, 0.3);
		pointer-events: none;
		z-index: 9998;
		display: none;
		box-sizing: border-box;
	}

	/* 调整点4: 添加状态信息样式 */
	.status-info {
		background-color: #f8f9fa;
		padding: 15px;
		border-radius: 8px;
		margin-bottom: 20px;
		border-left: 4px solid #3498db;
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
	}

	.status-item {
		display: flex;
		flex-direction: column;
	}

	.status-label {
		color: #7f8c8d;
		font-size: 0.9rem;
		margin-bottom: 5px;
	}

	.status-value {
		color: #2c3e50;
		font-weight: bold;
		font-size: 1.1rem;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.container {
			padding: 20px;
		}

		h1 {
			font-size: 2rem;
		}

		.demo-area {
			height: 400px;
		}

		.flag-container {
			width: 150px;
			height: 100px;
		}

		.flag-cloth {
			width: 120px;
			height: 80px;
		}

		/* 调整点5: 移动端广告尺寸调整 */
		.floating-ad {
			transform: scale(0.9);
		}

		.floating-ad:hover {
			transform: scale(0.95);
		}
	}
</style>